import bannermobile1 from './images/banner/1.webp'
import bannermobile2 from './images/banner/2.webp'
import bannermobile3 from './images/banner/3.webp'
import bannermobile4 from './images/banner/4.webp'
import bannerdesktop1 from './images/banner/5.webp'
import bannerdesktop2 from './images/banner/6.webp'
import bannerdesktop3 from './images/banner/7.webp'
import bannerdesktop4 from './images/banner/8.webp'

import newsShape1 from "./images/shapes/news-one-shape-1.png";

import location1 from "./images/blog/News/4.jpg";
import location2 from "./images/blog/News/1.jpg";
import location3 from "./images/blog/News/6.jpg";

import logo1 from "./images/shapes/logo1.jpg";
import logo2 from "./images/shapes/logo2.jpg";
import logo3 from "./images/shapes/logo3.jpg";
import logo4 from "./images/shapes/logo4.jpg";
import logo5 from "./images/shapes/logo5.jpg";
import testimonialImg1 from "./images/testimonial/img1.jpg";
import testimonialImg2 from "./images/testimonial/img2.jpg";
import testimonialImg3 from "./images/testimonial/img3.jpg";
import testimonialImg4 from "./images/testimonial/img4.jpg";
import testimonialImg5 from "./images/testimonial/img5.jpg";
import shape1 from "./images/shapes/testimonial-one-shape-1.png";
import bgImage from "./images/testimonial/Burjkhalifa.jpg";

import FourS from "./images/topTrendingProjects/4S.webp";
import DLF from "./images/topTrendingProjects/DLF.webp";
import M3MAltitude from "./images/topTrendingProjects/M3MAltitude.webp";
import SmartworldOneDXP from "./images/topTrendingProjects/SmartworldOneDXP.webp";
import WhitelandUrbanResort from "./images/topTrendingProjects/WhitelandUrbanResort.webp";

import backgroundImage from "./images/backgrounds/Dubai.jpg";

import DwarkaExpressway from "./images/toplocations/DwarkaExpressway.webp";
import GolfCOurseroad from "./images/toplocations/GolfCOurseroad.webp";
import NewGurgaon from "./images/toplocations/NewGurgaon.webp";
import SPR from "./images/toplocations/SPR.webp";

import DLFlogo from "./images/developerslogo/d.png";
import M3Mlogo from "./images/developerslogo/m3.png";
import SMARTWORLDlogo from "./images/developerslogo/sm.png";
import WHITELANDlogo from "./images/developerslogo/w.png";

import Godrej from "./images/developerslogo/g.png";
import Mahindra from "./images/developerslogo/mh.png";
import shapoorji from "./images/developerslogo/s.png";
import Shape1 from "./images/shapes/brand-one-shape-1.png";
import Shape2 from "./images/shapes/brand-one-shape-2.png";

import backgroundImagechoose from "./images/backgrounds/Serviceimage.png";
import choose from "./images/WhyChooseUs/choose.png";

import overviewImage from "./images/overview/1.jpg";

import Altitide from "./images/TrendingProjects/M3MAltitude.webp";
import Mansion from "./images/TrendingProjects/M3MMansion.webp";
import OneDxp from "./images/TrendingProjects/SmartworldOneDXP.webp";
import UrbanResort from "./images/TrendingProjects/WhitelandUrbanResort.webp";

import presence from "./images/OurPresence/ourpresence.webp";
import presencecolor from "./images/OurPresence/ourpresence2.webp";
import Bengaluru from "./images/OurPresence/Bengaluru.webp";
import Delhi from "./images/OurPresence/Delhi.webp";
import Dubai from "./images/OurPresence/Dubai.webp";
import Pune from "./images/OurPresence/Pune.webp";
import Mumbai from "./images/OurPresence/Mumbai.webp";
import Gurugram from "./images/OurPresence/Gurugram.webp";
import lodha from "./images/TrendingProjects/lodha.jpg"
import yeshwantpur from "./images/TrendingProjects/Ys.jpg"
import vanaha from "./images/TrendingProjects/ShapoorjiVanaha.jpg"

export const bannerData = [
  {large: bannerdesktop1,small:bannermobile1},
  {large:bannerdesktop2,small:bannermobile2},
  {large:bannerdesktop3,small:bannermobile3},
  {large:bannerdesktop4,small:bannermobile4}
];

// Overview Data
export const OverviewData = {
  overviewImage: overviewImage,
  buttonLabel: "Enquire Now",
  tagline: "Why buy with us?",
  caption: `Trust, expertise, premium properties, seamless service, and customer-first approach.`,

  description: [
    `Property Station is your trusted partner in finding the right property in Gurgaon, Pune, Mumbai, and Bangalore. As the top real estate agent in Gurgaon, we provide high-quality homes that match your lifestyle and investment goals. Whether you want luxury apartments or high-end villas, Property Station is here to help. We provide the best solutions with expert advice.

We are known as the top real estate company in Gurgaon. We have years of experience and a large property portfolio. Our client-first approach makes transactions smooth and easy. Our team of dedicated professionals takes pride in being the best real estate agent. We deliver personalized property recommendations just for you.

At Property Station, we know that buying or selling real estate is a big decision. As the top property consultant, we offer market insights, legal help, and full support to make the process easy. As a leading real estate agency, we focus on honesty, trust, and customer satisfaction. We ensure you get the best deals available.

If you are looking for properties in Gurgaon, Property Station can help. We provide access to popular developments, including luxury homes, gated communities, and commercial areas. We are also expanding our services to Pune, Mumbai, and Bangalore. We promise the same commitment to excellence. We connect you with properties that match your goals.

Whether you are buying your first home, investing, or upgrading your space, Property Station can help you reach your real estate goals. Enjoy a smooth and rewarding property journey with the leading experts in the industry.`,
  ],
  amenities: ["High Demand", "Future-Ready Smart Homes"],
  buttonmessage: "More details",
};

// Why Should Choose
export const whyshouldChooseData = {
  tagline: `  Why you should choose Property Station ?`,
  backgroundImage: backgroundImagechoose,
  Image1: choose,
  pointsList1: ["Market Expertise", "Smooth Deals", "Client Focused"],
  pointsList2: ["Proven Success", "Widely Trusted", "Post-Sales Care"],
};
// Hot Location
export const hotlocationData = {
  background: backgroundImage,
  title: `Featured Cities`,
  tagline: `Find your home in the city of your choice`,
  data: [
    {
      location: `Golf Course `,
      tag: ` Know More`,
      image: GolfCOurseroad,
      alt: `GolfCOurseroad`,
    },

    {
      location: `Dwarka Expressway`,
      tag: ` Know More`,
      image: DwarkaExpressway,
      alt: `DwarkaExpressway`,
    },
    {
      location: `New Gurugram`,
      tag: ` Know More`,
      image: NewGurgaon,
      alt: `NewGurgaon`,
    },
    {
      location: `SPR Road`,
      tag: ` Know More`,
      image: SPR,
      alt: `SPR`,
    },
  ],
};

// Top Developers
export const topDevelopersData = {
  shape1: Shape1,
  Shape2: Shape2,
  title: "Leading Real Estate Developers",
  data: [
    {
      image: DLFlogo,
      link: `/developers/dlf`,
    },
    {
      image: M3Mlogo,
      link: `/developers/m3m`,
    },
    {
      image: SMARTWORLDlogo,
      link: `/developers/smartworld`,
    },
    {
      image: WHITELANDlogo,
      link: `/developers/whiteland`,
    },
    {
      image: Mahindra,
      link: `/developers/mahindra-lifespaces`,
    },
    {
      image: Godrej,
      link: `/developers/godrej`,
    },
    {
      image: shapoorji,
      link: `/developers/shapoorji-pallonji`,
    },

  ],
};
// Top Trending
export const toptrendingprojectData = {
  tagline: `Top Trending Projects`,
  data: [
    {
      image: FourS,
      building: `3 & 4 BHK`,
      name: "4s The Aurrum",
    },
    {
      image: DLF,
      building: `4 BHK + SQ`,
      name: "DLF Privana North",
    },
    {
      image: SmartworldOneDXP,
      building: `3.5 & 4.5 BHK`,
      name: "Smartworld OneDXP",
    },
    {
      image: WhitelandUrbanResort,
      building: `3 & 4 BHK`,
      name: "Whiteland Westin Residences",
    },
    {
      image: M3MAltitude,
      building: `4.5 BHK`,
      name: "M3M Altitude",
    },
  ],
};

// Testimonial data
export const testimonialsData = {
  title: `What’s Happening`,
  message: ` what they’re saying about Property Station`,
  bgImage: bgImage,
  shape1: shape1,
  logo1: logo1,
  logo2: logo2,
  logo3: logo3,
  logo4: logo4,
  logo5: logo5,

  data: [
    {
      img: testimonialImg1,
      name: "Abhishek Singh",
      text: "Property Station helped me find my dream home with ease. Their expert team guided me through every step. Highly recommended!",
    },
    {
      img: testimonialImg2,
      name: "Sunita Dalal",
      text: "Exceptional service from Property Station! They made the entire buying process smooth and hassle-free. A great experience.",
    },
    {
      img: testimonialImg3,
      name: "Pankaj Verma",
      text: "Thanks to Property Station, I sold my property quickly and at a great price. Their professionalism truly stands out!",
    },
    {
      img: testimonialImg4,
      name: "Shivani Shrivastav",
      text: "Property Station’s agents were knowledgeable and responsive. They found the perfect investment property for me in no time.",
    },
    {
      img: testimonialImg5,
      name: "Rahul Sharma",
      text: "From start to finish, Property Station made my home-buying journey seamless. I couldn’t be happier with their service!",
    },
  ],
};

// Latest Update
export const LatestUpdate = {
  tagline: `Latest Updates`,
  shape1: newsShape1,
  data: [
    {
      id: 1,
      image: location1,
      alt: "Google",
      date: "01 Jan",
      tag: "Google Leases 5.5 Lakh Sq Ft Office Space in Gurugram.",
      title: `Google has secured a significant 550,000 sq ft of office space, `,
      link: "/news-070125",
      review: 2,
    },
    {
      id: 2,
      image: location2,
      alt: "TARC Ltd Reports Rs 1,165 Crore in Pre-Sales for Q3 FY25",
      date: "06 Jan",
      tag: "TARC Ltd Reports Rs 1,165 Crore in Pre-Sales for Q3 FY25",
      title: `TARC Ltd has reported impressive pre-sales of Rs 1,165 crore for Q3 FY25,`,
      link: "/news-080125",
      review: 3,
    },
    {
      id: 3,
      image: location3,
      alt: "Prestige Group Invests Rs 462",
      date: "30 Oct",
      tag: "Prestige Group Invests Rs 462 Crore to Acquire 17.45 Acres of Land",
      title: `Prestige Group has acquired a prime 17.45-acre
       land parcel in Bengaluru,`,
      link: "/news-090125",
      review: 5,
    },
  ],
};

export const HotProjectsData = {
  background: presence,
  title: "Trending Projects",
  caption: "Where Indian Landmarks Redefine Real Estate Excellence",
  location: "India",
  properties: [
    {
      title: "M3M Altitude",
      image: Altitide,
      address: "Sector 65, Gurugram",
      price: "On Request",
      url: `/m3m-altitude-sector-65-gurugram`,
      alt: "M3M Altitude",
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      title: "Lodha Divino",
      image: lodha,
      address: "Matunga East, Mumbai",
      price: "On Request",
      url: ``,
      alt: "lodha divino",
      form: {
        source_id: 11,
        api_userPublicKey: `LgsNgAVNQpv6sAGF8YLDkC2UTNSWU2WuOqlR5KPuWQ4xiNNBYtGNptV45TcKqdiG`,
        api_userSecretKey: `1oOummcs22cGcb8qO3hIGisxlz59bRHiiYvjaai0vUfPL7+VdbcNN7k=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "lodha", // Add or update the subject here
        to_email: "adarsh.paritosh@propertystation.in",
      }
    },
    {
      title: "M3M Mansion",
      image: Mansion,
      address: "Sector 113, Gurugram",
      price: "On Request",
      url: `/m3m-mansions-sector-113-gurugram`,
      alt: "M3M Mansion",
      form: {
        source_id: 11,
        api_userPublicKey: `LgsNgAVNQpv6sAGF8YLDkC2UTNSWU2WuOqlR5KPuWQ4xiNNBYtGNptV45TcKqdiG`,
        api_userSecretKey: `1oOummcs22cGcb8qO3hIGisxlz59bRHiiYvjaai0vUfPL7+VdbcNN7k=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M", // Add or update the subject here
        to_email: "adarsh.paritosh@propertystation.in",
      }
    },
    {
      title: "Godrej Yeswanthpur ",
      image: yeshwantpur,
      address: "Yeshwanthpur, Bengaluru",
      price: "On Request",
      url: ``,
      alt: "Godrej Yeswanthpur",
      form: {
        source_id: 11,
        api_userPublicKey: `QfGJfF5a/d+2jRx/SxYVz01NGUahn9aEfMaH0aKXN7HgLi3Nb5a6UcQLJ1PwF/WT`,
        api_userSecretKey: `SM1VoSXyTurWCoSNDsVbV7ppkh8Pd8JJj8QWzHAHdiPvuwzhJKDw++Y=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Godej", // Add or update the subject here
        to_email: "adarsh.paritosh@propertystation.in",
      }
    },
    {
      title: "DLF The Arbour",
      image: OneDxp,
      address: "Sector 63, Gurugram",
      price: "On Request",
      url: `/dlf-the-arbour`,
      alt: "DLF The Arbour",
      form: {
        source_id: 11,
        api_userPublicKey: `QfGJfF5a/d+2jRx/SxYVz01NGUahn9aEfMaH0aKXN7HgLi3Nb5a6UcQLJ1PwF/WT`,
        api_userSecretKey: `SM1VoSXyTurWCoSNDsVbV7ppkh8Pd8JJj8QWzHAHdiPvuwzhJKDw++Y=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "DLF Arbour", // Add or update the subject here
        to_email: "adarsh.paritosh@propertystation.in",
      }
    },
    {
      title: "Shapoorji Pallonji Golfland ",
      image: vanaha,
      address: "Vanaha, Pune",
      price: "On Request",
      url: `/shapoorji-pallonji-vanaha-bavdhan-pune`,
      alt: "Shapoorji Pallonji Vanaha",
      form: {
        source_id: 11,
        api_userPublicKey: `QfGJfF5a/d+2jRx/SxYVz01NGUahn9aEfMaH0aKXN7HgLi3Nb5a6UcQLJ1PwF/WT`,
        api_userSecretKey: `SM1VoSXyTurWCoSNDsVbV7ppkh8Pd8JJj8QWzHAHdiPvuwzhJKDw++Y=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Vanha", // Add or update the subject here
        to_email: "adarsh.paritosh@propertystation.in",
      }
    },
    {
      title: "Whiteland Westin Residences",
      image: UrbanResort,
      address: "Sector 103, Gurugram",
      price: "On Request",
      url: `/whiteland-westin-residences`,
      alt: "Whiteland Westin Residences",
      form: {
        source_id: 11,
        api_userPublicKey: `QfGJfF5a/d+2jRx/SxYVz01NGUahn9aEfMaH0aKXN7HgLi3Nb5a6UcQLJ1PwF/WT`,
        api_userSecretKey: `SM1VoSXyTurWCoSNDsVbV7ppkh8Pd8JJj8QWzHAHdiPvuwzhJKDw++Y=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Whiteland", // Add or update the subject here
        to_email: "adarsh.paritosh@propertystation.in",
      }
    },

  ],
  form_data: {
    api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
    api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
    source_id: 11,
    sub_source_id: 130,
    builder_id: `103`,
    project_id: `477`,
    subject: "Property Station enquiry", // Add or update the subject here
    to_email: "leads@gurugram-property.com",
  },
};

export const OurPresenceData = {
  background: presencecolor,
  title: "Featured Cities",
  location: "India",
  caption: "",
  location: [
    {
      image: Pune,
      name: "Pune",
      url: `/pune`,
      alt: `Pune`,
    },
    {
      image: Mumbai,
      name: "Mumbai",
      url: `/mumbai`,
      alt: `/mumbai`,
    },
    {
      image: Gurugram,
      name: "Gurugram",
      url: `/gurugram`,
      alt: `gurugram`,
    },
    {
      image: Bengaluru,
      name: "Bengaluru",
      url: `/bengaluru`,
      alt: `pune`,
    },
  ],
};

// export const formdata={
//    $api_userPublicKey : 'FutgeZL4HI2uFTs4B64BSu8w0SuL7/sZv40GWweD8VMD+xF4S6po7GgEu01s8BGd',
//    $api_userSecretKey : 'R0iOrYjUrdT6omGFx6um32sGOBHvjEFYZa6e3KMFN4dxIPU8+D0iNw==',
//    source_id:11,
//    sub_source_id:64,  
//    builder_id:'60', 
//    project_id:'490',
// }
export const whatsapp = {
  title: "Property Station",
  subTitle: "Happy may I Help You!",
  greetingText: "Hi there! \nHow can I help you?",
  ctaText: "Start Chat",
  whatsAppNumber: "7079429676",
  welcomeMessage:
    "Hi! I'm interested  to Buy Property, kindly share more details.",
}